<template>
<div class="c-substep step-3-1">
  <div class="c-substep-popup">
    <p>
      Opisz co to za miejsce, np.: strzeżony parking pod biurowcem, w którym pracuję
    </p>
    <input type="text" v-model="answerInput" placeholder="">
    <br>
    <button v-if="answerInput" v-on:click="answer(answer)">Dalej</button>
    <!-- <button class="white" v-on:click="goToMainPage()">Przejdź do strony głównej</button> -->
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

export default {
  name: 'step3-1',
  data() {
    return {
      answerInput: ''
    }
  },
  methods: {
    answer(answer) {
      this.$store.dispatch('answer', {
        step: '3',
        answer: this.answerInput,
        substep: '3-1',
        asSubstep: true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
